import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { api } from "../lib/api";

const DropListSignup = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/early-access", { email, source: "footer" });
      setState("done");
    } catch { setState("error"); }
  };

  if (state === "done") {
    return <p data-testid="footer-signup-success" className="mt-8 text-[#EDEEF1]">You're on the drop list. First to know, every time.</p>;
  }
  return (
    <form onSubmit={submit} data-testid="footer-signup-form" className="mt-8 max-w-md">
      <p className="label text-[#8A8F99] mb-3">Join the drop list — early access to every release</p>
      <div className="flex gap-2">
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="footer-signup-email" placeholder="you@email.com"
          className="flex-1 h-12 px-4 bg-transparent border border-white/25 text-[#EDEEF1] placeholder:text-[#8A8F99] outline-none focus:border-[#2B6BFF]"
        />
        <button
          data-testid="footer-signup-submit" disabled={state === "sending"}
          className="bg-[#2B6BFF] text-white px-6 h-12 label hover:bg-[#1F55D6] transition-colors disabled:opacity-50"
        >
          {state === "sending" ? "…" : "Join"}
        </button>
      </div>
      {state === "error" && <p data-testid="footer-signup-error" className="text-red-400 text-sm mt-2">That didn't go through — try again.</p>}
    </form>
  );
};

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0B0E14] text-[#EDEEF1]">
    <div className="w-full mx-auto px-4 sm:px-8 md:px-12 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="font-bodoni text-6xl md:text-8xl leading-none">FUNKY<span className="volt">.</span></p>
          <p className="label tracking-[0.4em] mt-1 opacity-70">APPAREL</p>
          <p className="mt-6 max-w-md text-[#8A8F99] text-lg">
            Funky Apparel — heavyweight streetwear, dropped in limited runs and shipped across the USA. No restock. No compromise.
          </p>
          <DropListSignup />
        </div>
        <div className="md:col-span-3">
          <p className="label text-[#8A8F99] mb-5">Explore</p>
          <ul className="space-y-3">
            <li><Link to="/shop" className="link-underline">All Pieces</Link></li>
            <li><Link to="/#story" className="link-underline">His Fight, Our Fight</Link></li>
            <li><Link to="/#manifesto" className="link-underline">Our Ethos</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="label text-[#8A8F99] mb-5">Client Care</p>
          <ul className="space-y-3 text-[#8A8F99]">
            <li>Shipping & Returns</li>
            <li>Size Guide</li>
            <li><Link to="/admin" className="link-underline text-[#EDEEF1]">Studio Login</Link></li>
          </ul>
          <p className="label text-[#8A8F99] mt-10 mb-4">Follow the Fight</p>
          <a
            href="https://www.instagram.com/funky.apparelll"
            target="_blank" rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 link-underline"
          >
            <Instagram className="w-5 h-5" strokeWidth={1.5} /> @funky.apparelll
          </a>
        </div>
      </div>
      <div className="mt-20 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 label text-[#8A8F99]">
        <span>© {new Date().getFullYear()} Funky Apparel</span>
        <span>Made in limited quantity</span>
      </div>
    </div>
  </footer>
);
